









import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		tag: {
			type: String,
			default: 'p',
		},
	},
	setup() {
		return {};
	},
});
